import React, { useState, useEffect } from "react";
import { Form, Dropdown, Button, Checkbox } from "semantic-ui-react";
import CardLayout from "./CardLayout";
import ReactTable from "react-table";
import PropTypes from "prop-types";

const CardDoctorSearch = ({
  preData,
  hideCallBack,
  getSearchDoctor,
  getSpecialitiesList,
  specialitiesList,
  doctorList,
  onSelectDoctor,
  doctorListLoading,
  numberOfPage,
  currentPage,
  onPageChange
}) => {
  const [togDoctorName, setTogDoctorName] = useState(true);
  const [togSpeciality, setTogSpeciality] = useState(false);

  const [doctorName, setDoctorName] = useState("");
  const [speciality, setSpeciality] = useState(null);

  const [clickTimeout, setClickTimeout] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [doctorSelected, setDoctorSelected] = useState(null);

  useEffect(() => {
    getSpecialitiesList();
  }, []);

  useEffect(() => {
    setDoctorName(preData)
    getSearchDoctor(preData, null);
  }, [preData])

  const handleToggleName = (e, { checked }) => {
    if (!checked) {
      setDoctorName("");
    }
    setTogDoctorName(checked);
  };

  const handleToggleSpecility = (e, { checked }) => {
    if (!checked) {
      setSpeciality(null);
    }
    setTogSpeciality(checked);
  };

  const handleOnChangeDoctorName = e => {
    setDoctorName(e.target.value);
  };

  const handleOnChangeSpeciality = (e, { value }) => {
    setSpeciality(value);
  };

  const handleOnSearchDoctor = async () => {
    setIsLoading(true);
    await getSearchDoctor(doctorName, speciality);
    setIsLoading(false);
  };

  const handlePageChange = async (page) => {
    setIsLoading(true);
    await onPageChange(doctorName, speciality, page + 1);
    setIsLoading(false);
  };

  const handleSelectClick = () => {
    if(doctorSelected){
      onSelectDoctor(
        doctorSelected.original.id,
        doctorSelected.original.full_name
      );
    }
    hideCallBack();
  }

  return (
    <CardLayout
      titleText="ค้นหาแพทย์"
      onClose={hideCallBack}
      toggleable={false}
      loading={isLoading}
    >
      <Form>
        <Form.Group inline>
          <Form.Checkbox
            toggle
            checked={togDoctorName}
            onChange={handleToggleName}
          />
          <Form.Field>
            <b>ชื่อ / รหัส</b>
          </Form.Field>
          <Form.Input
            width={6}
            disabled={!togDoctorName}
            value={doctorName}
            onChange={handleOnChangeDoctorName}
          ></Form.Input>
          <Form.Checkbox
            toggle
            checked={togSpeciality}
            onChange={handleToggleSpecility}
          />
          <Form.Field>
            <b>Speciality</b>
          </Form.Field>
          <Dropdown
            search
            selection
            disabled={!togSpeciality}
            value={speciality}
            options={specialitiesList}
            onChange={handleOnChangeSpeciality}
          ></Dropdown>
          <Form.Field />
          <Form.Button color="blue" onClick={handleOnSearchDoctor}>
            ค้นหา
          </Form.Button>
        </Form.Group>
      </Form>

      <ReactTable
        style={{ height: 400, backgroundColor: "#FFFFFF" }}
        manual
        data={doctorList}
        loading={isLoading}
        showPageSizeOptions={false}
        page={currentPage - 1}
        pages={numberOfPage}
        onPageChange={handlePageChange}
        getNoDataProps={() => {
          return { style: { display: "none" } };
        }}
        getTrProps={(state, rowInfo) => {
          if (rowInfo && rowInfo.row) {
            let background =
              rowInfo.index === (doctorSelected ? doctorSelected.index : null)
                ? "#CCE2FF"
                : "white";
            return {
              onClick: e => {
                setDoctorSelected(rowInfo);
                if (clickTimeout !== null) {
                  if (
                    (doctorSelected ? doctorSelected.index : null) ===
                    rowInfo.index
                  ) {
                    clearTimeout(clickTimeout);
                    setClickTimeout(null);
                    onSelectDoctor(
                      rowInfo.original.id,
                      rowInfo.original.full_name
                    );
                    hideCallBack();
                  }
                } else {
                  setClickTimeout(
                    setTimeout(() => {
                      clearTimeout(clickTimeout);
                      setClickTimeout(null);
                    }, 500)
                  );
                }
              },
              style: {
                background: background
              }
            };
          } else {
            return {};
          }
        }}
        columns={[
          {
            Header: "Name",
            accessor: "name_code"
          },
          {
            Header: "Specialty",
            accessor: "specialty",
            resizable: false
          }
        ]}
      ></ReactTable>
      <br />
      <Button
        color="blue"
        onClick={handleSelectClick}
      >
        เลือก
      </Button>
    </CardLayout>
  );
};

CardDoctorSearch.defaultProps = {
  preData: "",
  specialitiesList: [],
  doctorSearchList: [],
  doctorList: [],

  hideCallBack: () => {},
  getSpecialitiesList: () => {},
  getdoctorSearchList: () => {},
  onSelectDoctor: () => {},
  getSearchDoctor: () => {},
  onPageChange: () => {},
};

CardDoctorSearch.propTypes = {
  preData: PropTypes.string,
  specialitiesList: PropTypes.array,
  doctorSearchList: PropTypes.array,
  doctorList: PropTypes.array,

  hideCallBack: PropTypes.func,
  getSpecialitiesList: PropTypes.func,
  getdoctorSearchList: PropTypes.func,
  onSelectDoctor: PropTypes.func,
  getSearchDoctor: PropTypes.func,
  onPageChange: PropTypes.func,
};

export default React.memo(CardDoctorSearch);
